import { ContactsListView } from "@/components/features/contact/ContactsListView";
import { GlobalNotAuthorized } from "@/components/ui";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/contacts/")({
  component: RouteComponent,
  // TODO: Write out a validated search schema for contactSearchSchema
  // validateSearch: contactSearchSchema,
  pendingComponent: () => (
    <div className="flex w-full">
      <LawWorksLoader className="w-full" />
    </div>
  ),
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.contactsAll)) {
    return <GlobalNotAuthorized />;
  } else {
    return <ContactsListView />;
  }
}
